import { ANALYTICS_EVENTS, ANALYTICS_PROPERTY_KEYS, COMPONENT_OUTCOMES, DCM_PAGES } from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';

export type TrackLineItemNameEnteredParams = {
  campaignId?: string;
  lineItemId?: string;
  adAccountId?: string;
  lineItemName: string;
};

export const trackLineItemNameEntered = ({
  campaignId,
  lineItemId,
  adAccountId,
  lineItemName,
}: TrackLineItemNameEnteredParams): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.LINE_ITEM_NAME_ENTERED, {
    [ANALYTICS_PROPERTY_KEYS.CAMPAIGN_ID]: campaignId,
    [ANALYTICS_PROPERTY_KEYS.LINE_ITEM_ID]: lineItemId,
    [ANALYTICS_PROPERTY_KEYS.AD_ACCOUNT_ID]: adAccountId,
    [ANALYTICS_PROPERTY_KEYS.LINE_ITEM_NAME]: lineItemName,
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.CAMPAIGN_BUILDER,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};
